// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.becker-page {
  --bk-navy: #1B2A4A;
  --bk-navy-light: #243560;
  --bk-purple: #5A4B8A;
  --bk-purple-light:#7B6FAD;
  --bk-purple-pale: #EDE9F6;
  --bk-grey-900: #2C2C2C;
  --bk-grey-700: #555555;
  --bk-grey-500: #888888;
  --bk-grey-200: #E8E8EC;
  --bk-grey-100: #F4F4F7;
  --bk-white: #FFFFFF;
  --bk-accent: #4A7FC1;
  --bk-accent-light:#EBF2FB;
  --bk-font: "Open Sans", "PingFang TC", "Noto Sans TC", "Microsoft JhengHei", sans-serif;
  font-family: var(--bk-font);
  color: var(--bk-grey-900);
  background: var(--bk-white);
  line-height: 1.7;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Reset inside scope */
.becker-page *, .becker-page *::before, .becker-page *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.becker-page a {
  color: var(--bk-purple);
  text-decoration: none;
}

.becker-page a:hover {
  text-decoration: underline;
}

/* ── Layout helpers ── */
.bk-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 24px;
}

/* ── HERO ── */
.bk-hero {
  background: linear-gradient(135deg, var(--bk-navy) 0%, var(--bk-navy-light) 55%, var(--bk-purple) 100%);
  color: var(--bk-white);
  padding: 72px 24px 64px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.bk-hero::before {
  content: "";
  position: absolute;
  inset: 0;
  background: repeating-linear-gradient(-45deg, rgba(255, 255, 255, 0.015) 0px, rgba(255, 255, 255, 0.015) 1px, transparent 1px, transparent 32px);
}

.bk-hero__eyebrow {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.65);
  margin-bottom: 20px;
  position: relative;
}

.bk-hero__title {
  font-size: clamp(26px, 5vw, 42px);
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -0.01em;
  position: relative;
  max-width: 680px;
  margin: 0 auto 20px;
}

.bk-hero__subtitle {
  font-size: clamp(14px, 2.2vw, 17px);
  font-weight: 400;
  color: rgba(255, 255, 255, 0.78);
  max-width: 580px;
  margin: 0 auto 36px;
  line-height: 1.75;
  position: relative;
}

.bk-hero__cta {
  display: inline-block;
  background: var(--bk-white);
  color: var(--bk-navy);
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.04em;
  padding: 14px 36px;
  border-radius: 3px;
  position: relative;
  transition: background 0.2s, color 0.2s, transform 0.15s;
}

.becker-page .bk-hero__cta:hover {
  background: var(--bk-purple-pale);
  color: var(--bk-navy);
  text-decoration: none;
  transform: translateY(-1px);
}

/* ── SECTION BASE ── */
.bk-section {
  padding: 64px 24px;
}

.bk-section--alt {
  background: var(--bk-grey-100);
}

.bk-section--navy {
  background: var(--bk-navy);
  color: var(--bk-white);
}

.bk-section__label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--bk-purple);
  margin-bottom: 10px;
}

.bk-section--navy .bk-section__label {
  color: rgba(255, 255, 255, 0.5);
}

.bk-section__heading {
  font-size: clamp(20px, 3.5vw, 28px);
  font-weight: 700;
  color: var(--bk-navy);
  line-height: 1.3;
  margin-bottom: 16px;
}

.bk-section--navy .bk-section__heading {
  color: var(--bk-white);
}

.bk-section__lead {
  font-size: 15px;
  font-weight: 400;
  color: var(--bk-grey-700);
  max-width: 640px;
  line-height: 1.8;
  margin-bottom: 40px;
}

.bk-section--navy .bk-section__lead {
  color: rgba(255, 255, 255, 0.75);
}

/* ── DIVIDER ── */
.bk-divider {
  width: 40px;
  height: 3px;
  background: var(--bk-purple);
  border: none;
  margin: 0 0 28px;
}

.bk-section--navy .bk-divider {
  background: rgba(255, 255, 255, 0.3);
}

/* ── CHALLENGE LIST ── */
.bk-challenge-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 32px;
}

@media (max-width: 640px) {
  .bk-challenge-grid {
    grid-template-columns: 1fr;
  }
}
.bk-challenge-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: var(--bk-white);
  border: 1px solid var(--bk-grey-200);
  border-radius: 6px;
  padding: 16px 18px;
}

.bk-challenge-item__dot {
  flex-shrink: 0;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--bk-purple);
  margin-top: 7px;
}

.bk-challenge-item__text {
  font-size: 13.5px;
  font-weight: 400;
  color: var(--bk-grey-700);
  line-height: 1.65;
}

/* ── FOR WHO ── */
.bk-for-who-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-top: 32px;
}

@media (max-width: 600px) {
  .bk-for-who-grid {
    grid-template-columns: 1fr;
  }
}
.bk-for-who-item {
  background: var(--bk-purple-pale);
  border-left: 3px solid var(--bk-purple);
  border-radius: 0 6px 6px 0;
  padding: 16px 20px;
  font-size: 13.5px;
  font-weight: 400;
  color: var(--bk-grey-900);
  line-height: 1.65;
}

/* ── SERVICES ── */
.bk-services {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.bk-service-card {
  background: var(--bk-white);
  border: 1px solid var(--bk-grey-200);
  border-radius: 8px;
  overflow: hidden;
}

.bk-service-card__header {
  display: flex;
  align-items: center;
  gap: 16px;
  background: var(--bk-navy);
  color: var(--bk-white);
  padding: 20px 28px;
}

.bk-service-card__num {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.5);
  flex-shrink: 0;
}

.bk-service-card__title {
  font-size: clamp(15px, 2.5vw, 18px);
  font-weight: 600;
  line-height: 1.35;
}

.bk-service-card__body {
  padding: 28px 28px 24px;
}

.bk-service-card__desc {
  font-size: 14px;
  font-weight: 400;
  color: var(--bk-grey-700);
  line-height: 1.8;
  margin-bottom: 24px;
}

.bk-service-card__subheading {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.05em;
  color: var(--bk-navy);
  text-transform: uppercase;
  margin-bottom: 12px;
  margin-top: 20px;
}

.bk-list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.bk-list li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 13.5px;
  font-weight: 400;
  color: var(--bk-grey-700);
  line-height: 1.65;
}

.bk-list li::before {
  content: "";
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--bk-purple-light);
  margin-top: 7px;
}

.bk-note-box {
  background: var(--bk-accent-light);
  border-left: 3px solid var(--bk-accent);
  border-radius: 0 4px 4px 0;
  padding: 14px 18px;
  margin-top: 20px;
  font-size: 13px;
  font-weight: 400;
  color: var(--bk-grey-700);
  line-height: 1.7;
}

.bk-stat-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--bk-purple-pale);
  border-radius: 4px;
  padding: 10px 16px;
  margin-top: 16px;
  font-size: 13px;
  font-weight: 600;
  color: var(--bk-purple);
}

/* ── CPE TAGS ── */
.bk-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
}

.bk-tag {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.03em;
  color: var(--bk-navy);
  background: var(--bk-grey-100);
  border: 1px solid var(--bk-grey-200);
  border-radius: 3px;
  padding: 5px 12px;
}

/* ── STEPS ── */
.bk-steps {
  display: flex;
  flex-direction: column;
  gap: 0;
  position: relative;
  padding-left: 40px;
}

.bk-steps::before {
  content: "";
  position: absolute;
  left: 13px;
  top: 20px;
  bottom: 20px;
  width: 2px;
  background: var(--bk-grey-200);
}

.bk-step {
  position: relative;
  padding: 0 0 32px 24px;
}

.bk-step:last-child {
  padding-bottom: 0;
}

.bk-step__circle {
  position: absolute;
  left: -40px;
  top: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--bk-navy);
  color: var(--bk-white);
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0;
}

.bk-step__title {
  font-size: 15px;
  font-weight: 700;
  color: var(--bk-navy);
  margin-bottom: 6px;
  line-height: 1.4;
}

.bk-step__desc {
  font-size: 13.5px;
  font-weight: 400;
  color: var(--bk-grey-700);
  line-height: 1.75;
}

/* ── PERIOD BOX ── */
.bk-period-box {
  background: var(--bk-white);
  border: 1.5px solid var(--bk-purple);
  border-radius: 8px;
  padding: 28px 32px;
  margin-top: 32px;
}

.bk-period-box__heading {
  font-size: 14px;
  font-weight: 700;
  color: var(--bk-navy);
  margin-bottom: 12px;
}

.bk-period-box__text {
  font-size: 13.5px;
  font-weight: 400;
  color: var(--bk-grey-700);
  line-height: 1.8;
}

/* ── FAQ ── */
.bk-faq {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.bk-faq-item {
  border: 1px solid var(--bk-grey-200);
  border-radius: 6px;
  overflow: hidden;
}

/* CSS-only accordion using :target or checkbox trick */
.bk-faq-item input[type=checkbox] {
  display: none;
}

.bk-faq-item__label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 22px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: var(--bk-navy);
  line-height: 1.45;
  background: var(--bk-white);
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.15s;
}

.bk-faq-item__label:hover {
  background: var(--bk-grey-100);
}

.bk-faq-item__label::after {
  content: "+";
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--bk-grey-200);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 400;
  color: var(--bk-purple);
  line-height: 22px;
  text-align: center;
}

.bk-faq-item input[type=checkbox]:checked ~ .bk-faq-item__label {
  background: var(--bk-navy);
  color: var(--bk-white);
}

.bk-faq-item input[type=checkbox]:checked ~ .bk-faq-item__label::after {
  content: "−";
  background: rgba(255, 255, 255, 0.15);
  color: var(--bk-white);
}

.bk-faq-item__body {
  display: none;
  padding: 0 22px;
  background: var(--bk-grey-100);
}

.bk-faq-item input[type=checkbox]:checked ~ .bk-faq-item__body {
  display: block;
  padding: 18px 22px;
}

.bk-faq-item__body p {
  font-size: 13.5px;
  font-weight: 400;
  color: var(--bk-grey-700);
  line-height: 1.8;
}

/* ── PRICE ── */
.bk-price-block {
  text-align: center;
  padding: 56px 24px;
}

.bk-price-block__label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 12px;
}

.bk-price-block__amount {
  font-size: clamp(36px, 7vw, 56px);
  font-weight: 700;
  color: var(--bk-white);
  line-height: 1;
  margin-bottom: 6px;
  letter-spacing: -0.02em;
}

.bk-price-block__note {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.55);
  margin-bottom: 36px;
}

.bk-price-block__cta {
  display: inline-block;
  background: var(--bk-white);
  color: var(--bk-navy);
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.05em;
  padding: 16px 48px;
  border-radius: 3px;
}

.becker-page .bk-price-block__cta:hover {
  background: var(--bk-purple-pale);
  text-decoration: none;
}

.bk-price-includes {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
  margin-top: 40px;
}

.bk-price-include-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
}

.bk-price-include-item::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--bk-purple-light);
  flex-shrink: 0;
}

/* ── DISCLAIMER ── */
.bk-disclaimer {
  background: var(--bk-grey-100);
  border-top: 1px solid var(--bk-grey-200);
  padding: 40px 24px;
}

.bk-disclaimer__heading {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--bk-grey-700);
  margin-bottom: 14px;
}

.bk-disclaimer__text {
  font-size: 12.5px;
  font-weight: 400;
  color: var(--bk-grey-500);
  line-height: 1.85;
  max-width: 720px;
}

/* ── PURCHASE CHECKLIST ── */
.bk-checklist {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
}

.bk-checklist li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 14px;
  font-weight: 400;
  color: var(--bk-grey-700);
  line-height: 1.65;
}

.bk-checklist li::before {
  content: "";
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: 3px;
  border: 2px solid var(--bk-purple);
  margin-top: 3px;
}

/* ── WARNING BOX ── */
.bk-warning {
  background: #FFF8EC;
  border-left: 3px solid #C97A00;
  border-radius: 0 4px 4px 0;
  padding: 14px 18px;
  margin-top: 20px;
  font-size: 13px;
  color: #6B4800;
  line-height: 1.7;
}

/* ── LINE CTA BANNER ── */
.bk-line-banner {
  background: var(--bk-white);
  border: 1.5px solid var(--bk-grey-200);
  border-radius: 8px;
  padding: 24px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-top: 32px;
}

@media (max-width: 560px) {
  .bk-line-banner {
    flex-direction: column;
    text-align: center;
  }
}
.bk-line-banner__text {
  font-size: 14px;
  font-weight: 400;
  color: var(--bk-grey-700);
  line-height: 1.6;
}

.bk-line-banner__text strong {
  color: var(--bk-navy);
  font-weight: 700;
}

.bk-line-banner__btn {
  flex-shrink: 0;
  display: inline-block;
  background: var(--bk-navy);
  color: var(--bk-white);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.05em;
  padding: 12px 24px;
  border-radius: 3px;
}

.becker-page .bk-line-banner__btn:hover {
  background: var(--bk-navy-light);
  text-decoration: none;
}

/* ── CONSULTATION MODES ── */
.bk-consult-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 20px;
}

@media (max-width: 600px) {
  .bk-consult-grid {
    grid-template-columns: 1fr;
  }
}
.bk-consult-card {
  border: 1px solid var(--bk-grey-200);
  border-radius: 6px;
  padding: 20px;
}

.bk-consult-card__title {
  font-size: 13px;
  font-weight: 700;
  color: var(--bk-navy);
  margin-bottom: 8px;
}

.bk-consult-card__body {
  font-size: 13px;
  font-weight: 400;
  color: var(--bk-grey-700);
  line-height: 1.7;
}

/* ── RESPONSIVE ── */
@media (max-width: 480px) {
  .bk-hero {
    padding: 48px 20px 44px;
  }
  .bk-section {
    padding: 48px 20px;
  }
  .bk-service-card__header {
    padding: 16px 20px;
  }
  .bk-service-card__body {
    padding: 20px 20px 18px;
  }
  .bk-period-box {
    padding: 20px 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/cpaafter/styles/cpaafter.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACA,kBAAA;EACA,wBAAA;EACA,oBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,yBAAA;EAEA,uFAAA;EAEA,2BAAA;EACA,yBAAA;EACA,2BAAA;EACA,gBAAA;EACA,mCAAA;EACA,kCAAA;AAAA;;AAGA,uBAAA;AACA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;AAAA;;AAGA;EACA,uBAAA;EACA,qBAAA;AAAA;;AAEA;EACA,0BAAA;AACA;;AAEA,yBAAA;AACA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AACA;;AAEA,eAAA;AACA;EACA,uGAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AACA;;AAEA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,gJAAA;AACA;;AAQA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;EACA,kBAAA;AALA;;AAQA;EACA,iCAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AALA;;AAQA;EACA,mCAAA;EACA,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AALA;;AAQA;EACA,qBAAA;EACA,2BAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,wDAAA;AALA;;AAOA;EACA,iCAAA;EACA,qBAAA;EACA,qBAAA;EACA,2BAAA;AAJA;;AAOA,uBAAA;AACA;EACA,kBAAA;AAJA;;AAMA;EACA,8BAAA;AAHA;;AAKA;EACA,0BAAA;EACA,sBAAA;AAFA;;AAKA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;AAFA;;AAIA;EACA,+BAAA;AADA;;AAIA;EACA,mCAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;AADA;;AAGA;EACA,sBAAA;AAAA;;AAGA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAAA;;AAEA;EACA,gCAAA;AACA;;AAEA,kBAAA;AACA;EACA,WAAA;EACA,WAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AACA;;AACA;EACA,oCAAA;AAEA;;AACA,yBAAA;AACA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;AAEA;;AAAA;EACA;IAAqB,0BAAA;EAInB;AACF;AAFA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,2BAAA;EACA,oCAAA;EACA,kBAAA;EACA,kBAAA;AAIA;;AADA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;EACA,eAAA;AAIA;;AADA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;AAIA;;AADA,kBAAA;AACA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;AAIA;;AAFA;EACA;IAAmB,0BAAA;EAMjB;AACF;AAJA;EACA,iCAAA;EACA,uCAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;AAMA;;AAHA,mBAAA;AACA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAMA;;AAHA;EACA,2BAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;AAMA;;AAHA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,0BAAA;EACA,sBAAA;EACA,kBAAA;AAMA;;AAHA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,+BAAA;EACA,cAAA;AAMA;;AAHA;EACA,mCAAA;EACA,gBAAA;EACA,iBAAA;AAMA;;AAHA;EACA,uBAAA;AAMA;;AAHA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AAMA;;AAHA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAMA;;AAHA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAMA;;AAHA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;AAMA;;AAHA;EACA,WAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;AAMA;;AAHA;EACA,kCAAA;EACA,uCAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;AAMA;;AAHA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iCAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AAMA;;AAHA,mBAAA;AACA;EACA,aAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;AAMA;;AAJA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;AAOA;;AAJA,gBAAA;AACA;EACA,aAAA;EACA,sBAAA;EACA,MAAA;EACA,kBAAA;EACA,kBAAA;AAOA;;AAJA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,8BAAA;AAOA;;AAJA;EACA,kBAAA;EACA,sBAAA;AAOA;;AAJA;EAAsB,iBAAA;AAQtB;;AANA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AASA;;AANA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AASA;;AANA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;AASA;;AANA,qBAAA;AACA;EACA,2BAAA;EACA,oCAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AASA;;AANA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;AASA;;AANA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;AASA;;AANA,cAAA;AACA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AASA;;AANA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;AASA;;AANA,uDAAA;AACA;EACA,aAAA;AASA;;AANA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,2BAAA;EACA,yBAAA;UAAA,iBAAA;EACA,4BAAA;AASA;;AANA;EACA,8BAAA;AASA;;AANA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AASA;;AANA;EACA,0BAAA;EACA,sBAAA;AASA;;AANA;EACA,YAAA;EACA,qCAAA;EACA,sBAAA;AASA;;AANA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;AASA;;AANA;EACA,cAAA;EACA,kBAAA;AASA;;AANA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;AASA;;AANA,gBAAA;AACA;EACA,kBAAA;EACA,kBAAA;AASA;;AANA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,+BAAA;EACA,mBAAA;AASA;;AANA;EACA,iCAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;AASA;;AANA;EACA,eAAA;EACA,gCAAA;EACA,mBAAA;AASA;;AANA;EACA,qBAAA;EACA,2BAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AASA;;AAPA;EACA,iCAAA;EACA,qBAAA;AAUA;;AAPA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;AAUA;;AAPA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,+BAAA;AAUA;;AAPA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kCAAA;EACA,cAAA;AAUA;;AAPA,qBAAA;AACA;EACA,8BAAA;EACA,wCAAA;EACA,kBAAA;AAUA;;AAPA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;AAUA;;AAPA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;AAUA;;AAPA,6BAAA;AACA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAUA;;AAPA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;AAUA;;AAPA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;AAUA;;AAPA,sBAAA;AACA;EACA,mBAAA;EACA,8BAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAUA;;AAPA,0BAAA;AACA;EACA,2BAAA;EACA,sCAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;AAUA;;AAPA;EACA;IACI,sBAAA;IACA,kBAAA;EAUF;AACF;AAPA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;AASA;;AANA;EACA,qBAAA;EACA,gBAAA;AASA;;AANA;EACA,cAAA;EACA,qBAAA;EACA,0BAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AASA;;AAPA;EACA,gCAAA;EACA,qBAAA;AAUA;;AAPA,6BAAA;AACA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;AAUA;;AARA;EACA;IAAmB,0BAAA;EAYjB;AACF;AAVA;EACA,oCAAA;EACA,kBAAA;EACA,aAAA;AAYA;;AATA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;AAYA;;AATA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;AAYA;;AATA,qBAAA;AACA;EACA;IAAW,uBAAA;EAaT;EAZF;IAAc,kBAAA;EAeZ;EAdF;IAA2B,kBAAA;EAiBzB;EAhBF;IAAyB,uBAAA;EAmBvB;EAlBF;IAAiB,kBAAA;EAqBf;AACF","sourcesContent":[".becker-page {\r\n--bk-navy:        #1B2A4A;\r\n--bk-navy-light:  #243560;\r\n--bk-purple:      #5A4B8A;\r\n--bk-purple-light:#7B6FAD;\r\n--bk-purple-pale: #EDE9F6;\r\n--bk-grey-900:    #2C2C2C;\r\n--bk-grey-700:    #555555;\r\n--bk-grey-500:    #888888;\r\n--bk-grey-200:    #E8E8EC;\r\n--bk-grey-100:    #F4F4F7;\r\n--bk-white:       #FFFFFF;\r\n--bk-accent:      #4A7FC1;\r\n--bk-accent-light:#EBF2FB;\r\n\r\n--bk-font: 'Open Sans', 'PingFang TC', 'Noto Sans TC', 'Microsoft JhengHei', sans-serif;\r\n\r\nfont-family: var(--bk-font);\r\ncolor: var(--bk-grey-900);\r\nbackground: var(--bk-white);\r\nline-height: 1.7;\r\n-webkit-font-smoothing: antialiased;\r\n-moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n/* Reset inside scope */\r\n.becker-page *, .becker-page *::before, .becker-page *::after {\r\nbox-sizing: border-box;\r\nmargin: 0;\r\npadding: 0;\r\n}\r\n\r\n.becker-page a {\r\ncolor: var(--bk-purple);\r\ntext-decoration: none;\r\n}\r\n.becker-page a:hover {\r\ntext-decoration: underline;\r\n}\r\n\r\n/* ── Layout helpers ── */\r\n.bk-container {\r\nmax-width: 900px;\r\nmargin: 0 auto;\r\npadding: 0 24px;\r\n}\r\n\r\n/* ── HERO ── */\r\n.bk-hero {\r\nbackground: linear-gradient(135deg, var(--bk-navy) 0%, var(--bk-navy-light) 55%, var(--bk-purple) 100%);\r\ncolor: var(--bk-white);\r\npadding: 72px 24px 64px;\r\ntext-align: center;\r\nposition: relative;\r\noverflow: hidden;\r\n}\r\n\r\n.bk-hero::before {\r\ncontent: '';\r\nposition: absolute;\r\ninset: 0;\r\nbackground: repeating-linear-gradient(\r\n    -45deg,\r\n    rgba(255,255,255,0.015) 0px,\r\n    rgba(255,255,255,0.015) 1px,\r\n    transparent 1px,\r\n    transparent 32px\r\n);\r\n}\r\n\r\n.bk-hero__eyebrow {\r\ndisplay: inline-block;\r\nfont-size: 11px;\r\nfont-weight: 600;\r\nletter-spacing: 0.18em;\r\ntext-transform: uppercase;\r\ncolor: rgba(255,255,255,0.65);\r\nmargin-bottom: 20px;\r\nposition: relative;\r\n}\r\n\r\n.bk-hero__title {\r\nfont-size: clamp(26px, 5vw, 42px);\r\nfont-weight: 700;\r\nline-height: 1.25;\r\nletter-spacing: -0.01em;\r\nposition: relative;\r\nmax-width: 680px;\r\nmargin: 0 auto 20px;\r\n}\r\n\r\n.bk-hero__subtitle {\r\nfont-size: clamp(14px, 2.2vw, 17px);\r\nfont-weight: 400;\r\ncolor: rgba(255,255,255,0.78);\r\nmax-width: 580px;\r\nmargin: 0 auto 36px;\r\nline-height: 1.75;\r\nposition: relative;\r\n}\r\n\r\n.bk-hero__cta {\r\ndisplay: inline-block;\r\nbackground: var(--bk-white);\r\ncolor: var(--bk-navy);\r\nfont-size: 14px;\r\nfont-weight: 700;\r\nletter-spacing: 0.04em;\r\npadding: 14px 36px;\r\nborder-radius: 3px;\r\nposition: relative;\r\ntransition: background 0.2s, color 0.2s, transform 0.15s;\r\n}\r\n.becker-page .bk-hero__cta:hover {\r\nbackground: var(--bk-purple-pale);\r\ncolor: var(--bk-navy);\r\ntext-decoration: none;\r\ntransform: translateY(-1px);\r\n}\r\n\r\n/* ── SECTION BASE ── */\r\n.bk-section {\r\npadding: 64px 24px;\r\n}\r\n.bk-section--alt {\r\nbackground: var(--bk-grey-100);\r\n}\r\n.bk-section--navy {\r\nbackground: var(--bk-navy);\r\ncolor: var(--bk-white);\r\n}\r\n\r\n.bk-section__label {\r\nfont-size: 11px;\r\nfont-weight: 600;\r\nletter-spacing: 0.18em;\r\ntext-transform: uppercase;\r\ncolor: var(--bk-purple);\r\nmargin-bottom: 10px;\r\n}\r\n.bk-section--navy .bk-section__label {\r\ncolor: rgba(255,255,255,0.5);\r\n}\r\n\r\n.bk-section__heading {\r\nfont-size: clamp(20px, 3.5vw, 28px);\r\nfont-weight: 700;\r\ncolor: var(--bk-navy);\r\nline-height: 1.3;\r\nmargin-bottom: 16px;\r\n}\r\n.bk-section--navy .bk-section__heading {\r\ncolor: var(--bk-white);\r\n}\r\n\r\n.bk-section__lead {\r\nfont-size: 15px;\r\nfont-weight: 400;\r\ncolor: var(--bk-grey-700);\r\nmax-width: 640px;\r\nline-height: 1.8;\r\nmargin-bottom: 40px;\r\n}\r\n.bk-section--navy .bk-section__lead {\r\ncolor: rgba(255,255,255,0.75);\r\n}\r\n\r\n/* ── DIVIDER ── */\r\n.bk-divider {\r\nwidth: 40px;\r\nheight: 3px;\r\nbackground: var(--bk-purple);\r\nborder: none;\r\nmargin: 0 0 28px;\r\n}\r\n.bk-section--navy .bk-divider {\r\nbackground: rgba(255,255,255,0.3);\r\n}\r\n\r\n/* ── CHALLENGE LIST ── */\r\n.bk-challenge-grid {\r\ndisplay: grid;\r\ngrid-template-columns: 1fr 1fr;\r\ngap: 12px;\r\nmargin-top: 32px;\r\n}\r\n@media (max-width: 640px) {\r\n.bk-challenge-grid { grid-template-columns: 1fr; }\r\n}\r\n\r\n.bk-challenge-item {\r\ndisplay: flex;\r\nalign-items: flex-start;\r\ngap: 12px;\r\nbackground: var(--bk-white);\r\nborder: 1px solid var(--bk-grey-200);\r\nborder-radius: 6px;\r\npadding: 16px 18px;\r\n}\r\n\r\n.bk-challenge-item__dot {\r\nflex-shrink: 0;\r\nwidth: 7px;\r\nheight: 7px;\r\nborder-radius: 50%;\r\nbackground: var(--bk-purple);\r\nmargin-top: 7px;\r\n}\r\n\r\n.bk-challenge-item__text {\r\nfont-size: 13.5px;\r\nfont-weight: 400;\r\ncolor: var(--bk-grey-700);\r\nline-height: 1.65;\r\n}\r\n\r\n/* ── FOR WHO ── */\r\n.bk-for-who-grid {\r\ndisplay: grid;\r\ngrid-template-columns: 1fr 1fr;\r\ngap: 14px;\r\nmargin-top: 32px;\r\n}\r\n@media (max-width: 600px) {\r\n.bk-for-who-grid { grid-template-columns: 1fr; }\r\n}\r\n\r\n.bk-for-who-item {\r\nbackground: var(--bk-purple-pale);\r\nborder-left: 3px solid var(--bk-purple);\r\nborder-radius: 0 6px 6px 0;\r\npadding: 16px 20px;\r\nfont-size: 13.5px;\r\nfont-weight: 400;\r\ncolor: var(--bk-grey-900);\r\nline-height: 1.65;\r\n}\r\n\r\n/* ── SERVICES ── */\r\n.bk-services {\r\ndisplay: flex;\r\nflex-direction: column;\r\ngap: 32px;\r\n}\r\n\r\n.bk-service-card {\r\nbackground: var(--bk-white);\r\nborder: 1px solid var(--bk-grey-200);\r\nborder-radius: 8px;\r\noverflow: hidden;\r\n}\r\n\r\n.bk-service-card__header {\r\ndisplay: flex;\r\nalign-items: center;\r\ngap: 16px;\r\nbackground: var(--bk-navy);\r\ncolor: var(--bk-white);\r\npadding: 20px 28px;\r\n}\r\n\r\n.bk-service-card__num {\r\nfont-size: 11px;\r\nfont-weight: 700;\r\nletter-spacing: 0.12em;\r\ntext-transform: uppercase;\r\ncolor: rgba(255,255,255,0.5);\r\nflex-shrink: 0;\r\n}\r\n\r\n.bk-service-card__title {\r\nfont-size: clamp(15px, 2.5vw, 18px);\r\nfont-weight: 600;\r\nline-height: 1.35;\r\n}\r\n\r\n.bk-service-card__body {\r\npadding: 28px 28px 24px;\r\n}\r\n\r\n.bk-service-card__desc {\r\nfont-size: 14px;\r\nfont-weight: 400;\r\ncolor: var(--bk-grey-700);\r\nline-height: 1.8;\r\nmargin-bottom: 24px;\r\n}\r\n\r\n.bk-service-card__subheading {\r\nfont-size: 13px;\r\nfont-weight: 700;\r\nletter-spacing: 0.05em;\r\ncolor: var(--bk-navy);\r\ntext-transform: uppercase;\r\nmargin-bottom: 12px;\r\nmargin-top: 20px;\r\n}\r\n\r\n.bk-list {\r\nlist-style: none;\r\ndisplay: flex;\r\nflex-direction: column;\r\ngap: 8px;\r\n}\r\n\r\n.bk-list li {\r\ndisplay: flex;\r\nalign-items: flex-start;\r\ngap: 10px;\r\nfont-size: 13.5px;\r\nfont-weight: 400;\r\ncolor: var(--bk-grey-700);\r\nline-height: 1.65;\r\n}\r\n\r\n.bk-list li::before {\r\ncontent: '';\r\nflex-shrink: 0;\r\nwidth: 6px;\r\nheight: 6px;\r\nborder-radius: 50%;\r\nbackground: var(--bk-purple-light);\r\nmargin-top: 7px;\r\n}\r\n\r\n.bk-note-box {\r\nbackground: var(--bk-accent-light);\r\nborder-left: 3px solid var(--bk-accent);\r\nborder-radius: 0 4px 4px 0;\r\npadding: 14px 18px;\r\nmargin-top: 20px;\r\nfont-size: 13px;\r\nfont-weight: 400;\r\ncolor: var(--bk-grey-700);\r\nline-height: 1.7;\r\n}\r\n\r\n.bk-stat-badge {\r\ndisplay: inline-flex;\r\nalign-items: center;\r\ngap: 8px;\r\nbackground: var(--bk-purple-pale);\r\nborder-radius: 4px;\r\npadding: 10px 16px;\r\nmargin-top: 16px;\r\nfont-size: 13px;\r\nfont-weight: 600;\r\ncolor: var(--bk-purple);\r\n}\r\n\r\n/* ── CPE TAGS ── */\r\n.bk-tags {\r\ndisplay: flex;\r\nflex-wrap: wrap;\r\ngap: 8px;\r\nmargin-top: 16px;\r\n}\r\n.bk-tag {\r\nfont-size: 12px;\r\nfont-weight: 600;\r\nletter-spacing: 0.03em;\r\ncolor: var(--bk-navy);\r\nbackground: var(--bk-grey-100);\r\nborder: 1px solid var(--bk-grey-200);\r\nborder-radius: 3px;\r\npadding: 5px 12px;\r\n}\r\n\r\n/* ── STEPS ── */\r\n.bk-steps {\r\ndisplay: flex;\r\nflex-direction: column;\r\ngap: 0;\r\nposition: relative;\r\npadding-left: 40px;\r\n}\r\n\r\n.bk-steps::before {\r\ncontent: '';\r\nposition: absolute;\r\nleft: 13px;\r\ntop: 20px;\r\nbottom: 20px;\r\nwidth: 2px;\r\nbackground: var(--bk-grey-200);\r\n}\r\n\r\n.bk-step {\r\nposition: relative;\r\npadding: 0 0 32px 24px;\r\n}\r\n\r\n.bk-step:last-child { padding-bottom: 0; }\r\n\r\n.bk-step__circle {\r\nposition: absolute;\r\nleft: -40px;\r\ntop: 0;\r\nwidth: 28px;\r\nheight: 28px;\r\nborder-radius: 50%;\r\nbackground: var(--bk-navy);\r\ncolor: var(--bk-white);\r\nfont-size: 11px;\r\nfont-weight: 700;\r\ndisplay: flex;\r\nalign-items: center;\r\njustify-content: center;\r\nletter-spacing: 0;\r\n}\r\n\r\n.bk-step__title {\r\nfont-size: 15px;\r\nfont-weight: 700;\r\ncolor: var(--bk-navy);\r\nmargin-bottom: 6px;\r\nline-height: 1.4;\r\n}\r\n\r\n.bk-step__desc {\r\nfont-size: 13.5px;\r\nfont-weight: 400;\r\ncolor: var(--bk-grey-700);\r\nline-height: 1.75;\r\n}\r\n\r\n/* ── PERIOD BOX ── */\r\n.bk-period-box {\r\nbackground: var(--bk-white);\r\nborder: 1.5px solid var(--bk-purple);\r\nborder-radius: 8px;\r\npadding: 28px 32px;\r\nmargin-top: 32px;\r\n}\r\n\r\n.bk-period-box__heading {\r\nfont-size: 14px;\r\nfont-weight: 700;\r\ncolor: var(--bk-navy);\r\nmargin-bottom: 12px;\r\n}\r\n\r\n.bk-period-box__text {\r\nfont-size: 13.5px;\r\nfont-weight: 400;\r\ncolor: var(--bk-grey-700);\r\nline-height: 1.8;\r\n}\r\n\r\n/* ── FAQ ── */\r\n.bk-faq {\r\ndisplay: flex;\r\nflex-direction: column;\r\ngap: 2px;\r\n}\r\n\r\n.bk-faq-item {\r\nborder: 1px solid var(--bk-grey-200);\r\nborder-radius: 6px;\r\noverflow: hidden;\r\n}\r\n\r\n/* CSS-only accordion using :target or checkbox trick */\r\n.bk-faq-item input[type=\"checkbox\"] {\r\ndisplay: none;\r\n}\r\n\r\n.bk-faq-item__label {\r\ndisplay: flex;\r\nalign-items: center;\r\njustify-content: space-between;\r\ngap: 16px;\r\npadding: 18px 22px;\r\ncursor: pointer;\r\nfont-size: 14px;\r\nfont-weight: 600;\r\ncolor: var(--bk-navy);\r\nline-height: 1.45;\r\nbackground: var(--bk-white);\r\nuser-select: none;\r\ntransition: background 0.15s;\r\n}\r\n\r\n.bk-faq-item__label:hover {\r\nbackground: var(--bk-grey-100);\r\n}\r\n\r\n.bk-faq-item__label::after {\r\ncontent: '+';\r\nflex-shrink: 0;\r\nwidth: 22px;\r\nheight: 22px;\r\nborder-radius: 50%;\r\nbackground: var(--bk-grey-200);\r\ndisplay: flex;\r\nalign-items: center;\r\njustify-content: center;\r\nfont-size: 16px;\r\nfont-weight: 400;\r\ncolor: var(--bk-purple);\r\nline-height: 22px;\r\ntext-align: center;\r\n}\r\n\r\n.bk-faq-item input[type=\"checkbox\"]:checked ~ .bk-faq-item__label {\r\nbackground: var(--bk-navy);\r\ncolor: var(--bk-white);\r\n}\r\n\r\n.bk-faq-item input[type=\"checkbox\"]:checked ~ .bk-faq-item__label::after {\r\ncontent: '−';\r\nbackground: rgba(255,255,255,0.15);\r\ncolor: var(--bk-white);\r\n}\r\n\r\n.bk-faq-item__body {\r\ndisplay: none;\r\npadding: 0 22px;\r\nbackground: var(--bk-grey-100);\r\n}\r\n\r\n.bk-faq-item input[type=\"checkbox\"]:checked ~ .bk-faq-item__body {\r\ndisplay: block;\r\npadding: 18px 22px;\r\n}\r\n\r\n.bk-faq-item__body p {\r\nfont-size: 13.5px;\r\nfont-weight: 400;\r\ncolor: var(--bk-grey-700);\r\nline-height: 1.8;\r\n}\r\n\r\n/* ── PRICE ── */\r\n.bk-price-block {\r\ntext-align: center;\r\npadding: 56px 24px;\r\n}\r\n\r\n.bk-price-block__label {\r\nfont-size: 12px;\r\nfont-weight: 600;\r\nletter-spacing: 0.16em;\r\ntext-transform: uppercase;\r\ncolor: rgba(255,255,255,0.5);\r\nmargin-bottom: 12px;\r\n}\r\n\r\n.bk-price-block__amount {\r\nfont-size: clamp(36px, 7vw, 56px);\r\nfont-weight: 700;\r\ncolor: var(--bk-white);\r\nline-height: 1;\r\nmargin-bottom: 6px;\r\nletter-spacing: -0.02em;\r\n}\r\n\r\n.bk-price-block__note {\r\nfont-size: 13px;\r\ncolor: rgba(255,255,255,0.55);\r\nmargin-bottom: 36px;\r\n}\r\n\r\n.bk-price-block__cta {\r\ndisplay: inline-block;\r\nbackground: var(--bk-white);\r\ncolor: var(--bk-navy);\r\nfont-size: 14px;\r\nfont-weight: 700;\r\nletter-spacing: 0.05em;\r\npadding: 16px 48px;\r\nborder-radius: 3px;\r\n}\r\n.becker-page .bk-price-block__cta:hover {\r\nbackground: var(--bk-purple-pale);\r\ntext-decoration: none;\r\n}\r\n\r\n.bk-price-includes {\r\ndisplay: flex;\r\nflex-wrap: wrap;\r\njustify-content: center;\r\ngap: 16px;\r\nmargin-top: 40px;\r\n}\r\n\r\n.bk-price-include-item {\r\ndisplay: flex;\r\nalign-items: center;\r\ngap: 8px;\r\nfont-size: 13px;\r\ncolor: rgba(255,255,255,0.7);\r\n}\r\n\r\n.bk-price-include-item::before {\r\ncontent: '';\r\nwidth: 6px;\r\nheight: 6px;\r\nborder-radius: 50%;\r\nbackground: var(--bk-purple-light);\r\nflex-shrink: 0;\r\n}\r\n\r\n/* ── DISCLAIMER ── */\r\n.bk-disclaimer {\r\nbackground: var(--bk-grey-100);\r\nborder-top: 1px solid var(--bk-grey-200);\r\npadding: 40px 24px;\r\n}\r\n\r\n.bk-disclaimer__heading {\r\nfont-size: 13px;\r\nfont-weight: 700;\r\nletter-spacing: 0.06em;\r\ntext-transform: uppercase;\r\ncolor: var(--bk-grey-700);\r\nmargin-bottom: 14px;\r\n}\r\n\r\n.bk-disclaimer__text {\r\nfont-size: 12.5px;\r\nfont-weight: 400;\r\ncolor: var(--bk-grey-500);\r\nline-height: 1.85;\r\nmax-width: 720px;\r\n}\r\n\r\n/* ── PURCHASE CHECKLIST ── */\r\n.bk-checklist {\r\nlist-style: none;\r\ndisplay: flex;\r\nflex-direction: column;\r\ngap: 10px;\r\nmargin-top: 20px;\r\n}\r\n\r\n.bk-checklist li {\r\ndisplay: flex;\r\nalign-items: flex-start;\r\ngap: 12px;\r\nfont-size: 14px;\r\nfont-weight: 400;\r\ncolor: var(--bk-grey-700);\r\nline-height: 1.65;\r\n}\r\n\r\n.bk-checklist li::before {\r\ncontent: '';\r\nflex-shrink: 0;\r\nwidth: 18px;\r\nheight: 18px;\r\nborder-radius: 3px;\r\nborder: 2px solid var(--bk-purple);\r\nmargin-top: 3px;\r\n}\r\n\r\n/* ── WARNING BOX ── */\r\n.bk-warning {\r\nbackground: #FFF8EC;\r\nborder-left: 3px solid #C97A00;\r\nborder-radius: 0 4px 4px 0;\r\npadding: 14px 18px;\r\nmargin-top: 20px;\r\nfont-size: 13px;\r\ncolor: #6B4800;\r\nline-height: 1.7;\r\n}\r\n\r\n/* ── LINE CTA BANNER ── */\r\n.bk-line-banner {\r\nbackground: var(--bk-white);\r\nborder: 1.5px solid var(--bk-grey-200);\r\nborder-radius: 8px;\r\npadding: 24px 28px;\r\ndisplay: flex;\r\nalign-items: center;\r\njustify-content: space-between;\r\ngap: 24px;\r\nmargin-top: 32px;\r\n}\r\n\r\n@media (max-width: 560px) {\r\n.bk-line-banner {\r\n    flex-direction: column;\r\n    text-align: center;\r\n}\r\n}\r\n\r\n.bk-line-banner__text {\r\nfont-size: 14px;\r\nfont-weight: 400;\r\ncolor: var(--bk-grey-700);\r\nline-height: 1.6;\r\n}\r\n\r\n.bk-line-banner__text strong {\r\ncolor: var(--bk-navy);\r\nfont-weight: 700;\r\n}\r\n\r\n.bk-line-banner__btn {\r\nflex-shrink: 0;\r\ndisplay: inline-block;\r\nbackground: var(--bk-navy);\r\ncolor: var(--bk-white);\r\nfont-size: 13px;\r\nfont-weight: 700;\r\nletter-spacing: 0.05em;\r\npadding: 12px 24px;\r\nborder-radius: 3px;\r\n}\r\n.becker-page .bk-line-banner__btn:hover {\r\nbackground: var(--bk-navy-light);\r\ntext-decoration: none;\r\n}\r\n\r\n/* ── CONSULTATION MODES ── */\r\n.bk-consult-grid {\r\ndisplay: grid;\r\ngrid-template-columns: 1fr 1fr;\r\ngap: 16px;\r\nmargin-top: 20px;\r\n}\r\n@media (max-width: 600px) {\r\n.bk-consult-grid { grid-template-columns: 1fr; }\r\n}\r\n\r\n.bk-consult-card {\r\nborder: 1px solid var(--bk-grey-200);\r\nborder-radius: 6px;\r\npadding: 20px;\r\n}\r\n\r\n.bk-consult-card__title {\r\nfont-size: 13px;\r\nfont-weight: 700;\r\ncolor: var(--bk-navy);\r\nmargin-bottom: 8px;\r\n}\r\n\r\n.bk-consult-card__body {\r\nfont-size: 13px;\r\nfont-weight: 400;\r\ncolor: var(--bk-grey-700);\r\nline-height: 1.7;\r\n}\r\n\r\n/* ── RESPONSIVE ── */\r\n@media (max-width: 480px) {\r\n.bk-hero { padding: 48px 20px 44px; }\r\n.bk-section { padding: 48px 20px; }\r\n.bk-service-card__header { padding: 16px 20px; }\r\n.bk-service-card__body { padding: 20px 20px 18px; }\r\n.bk-period-box { padding: 20px 20px; }\r\n}\r\n            "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
